<template>
  <a
    v-if="$lang === 'en'"
    class="link dark font-normal text-14"
    :href="reportLink"
    target="_blank"
    rel="noopener"
  >
    <svg role="presentation" focusable="false" tabindex="-1" :class="['icon icon-xs mr-1', { 'lg:hidden': currentTab }]"
       
      alt=""
      svg-inline
     fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <path fill="currentColor" d="M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32Z"/>
  <path fill="#fff" fill-rule="evenodd" clip-rule="evenodd" d="M16 4.3a2.9 2.9 0 0 1 2.9 3.1l-1.2 10.3c0 .9-.8 1.5-1.6 1.5-1 0-1.6-.6-1.7-1.5L13.2 7.4A2.8 2.8 0 0 1 16 4.3Z"/>
  <path fill="#fff" d="M16 26.7a2.1 2.1 0 1 0 0-4.3 2.1 2.1 0 0 0 0 4.3Z"/>
</svg>{{ $t('report_problem') }}
  </a>
</template>

<script lang="ts" setup>
import type { PaymentType, Corridor } from '@core/types/imt'

const props = withDefaults(
  defineProps<{
    currentTab?: PaymentType | null
  }>(),
  { currentTab: null },
)

const { $lang, $cookie, $t } = useNuxtApp()

const corridor = inject('corridor') as Corridor

const reportLink = computed(() => {
  return (
    $t('links.report_issue') +
    '#' +
    `user_id=${$cookie.value.getId() || ''}&` +
    `corridor=${corridor.countryFrom.iso}/${corridor.countryTo.iso}/${corridor.currencyFrom.iso}/${
      corridor.currencyTo.iso
    }/${corridor.amount || corridor.defaultAmount}&` +
    `device=${$cookie.value.getDevice() || 'desktop'}&` +
    `lang=${$lang}&` +
    `comparison_section_type=${props.currentTab}` +
    `&layout=boxed`
  )
})
</script>
